import { render, staticRenderFns } from "./accept-info.vue?vue&type=template&id=e41dbec0&"
import script from "./accept-info.vue?vue&type=script&lang=js&"
export * from "./accept-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports